import React, { useEffect, useState } from 'react';
import { Size, WindowSizeContext } from '../WindowSizeContext';

interface WindowSizeProviderProps {
	children: React.ReactNode;
}

export const WindowSizeProvider = ({ children }: WindowSizeProviderProps) => {
	const [windowSize, setWindowSize] = useState<Size>({
		width: undefined,
		height: undefined
	});

	useEffect(() => {
		// Handler to call on window resize
		const handleResize = () => {
			// Set window width/height to state
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight
			});
		};
		// Add event listener
		window.addEventListener('resize', handleResize);
		handleResize(); // Call handler right away so state gets updated with initial window size

		return () => window.removeEventListener('resize', handleResize); // Remove event listener on cleanup
	}, []);

	return (
		<WindowSizeContext.Provider value={{ size: windowSize }}>
			{children}
		</WindowSizeContext.Provider>
	);
};
